import script from "./NavbarVue.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarVue.vue?vue&type=script&setup=true&lang=js"

import "./NavbarVue.vue?vue&type=style&index=0&id=0828a79b&lang=css"

const __exports__ = script;

export default __exports__